/* eslint-disable local/no-non-orangelogic-images-eslint */
import { useIntl } from "react-intl";

import { EnterpriseHero } from "@/components/enterprise/enterprise-hero-v2/src/enterprise-hero";

export const EnterpriseTabContent = () => {
    const intl = useIntl();

    return (
        <EnterpriseHero
            headerText={intl.formatMessage({
                id: "EnterpriseLandingPage.hero.enterprise-new.headerText",
                defaultMessage: "Forward Together"
            })}
            bodyText={intl.formatMessage({
                id: "EnterpriseLandingPage.hero.enterprise-new.bodyText",
                defaultMessage:
                    "Discover how Atlassian Williams Racing is accelerating teamwork transformation on the grid using the Atlassian Cloud Platform."
            })}
            cta={{
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.hero.enterprise.cta",
                    defaultMessage: "Watch video"
                }),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "heroSection",
                    "data-event": "clicked",
                    "data-label": "enterprise-hero-enterprise-cta",
                    "data-label-english": "Watch video"
                },
                href: "https://www.youtube.com/watch?v=sSKY7pNdlvI"
            }}
            ctaType="link"
            color="dark"
            backgroundImgSrc={{
                xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-sm-107626183.webp",
                sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-md-2984500272.webp",
                md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-lg-2107118674.webp",
                lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-1621379571.webp"
            }}
        />
    );
};
